import React from 'react';
import './RolesPage.css';
import { useState } from 'react';
import { PageHead, SectionHeader, SectionWrap, Rule } from '../../Components/index';
import { useTranslation } from 'react-i18next';


import { useEffect } from 'react';
import LoadingPage from '../LoadingPage/LoadingPage';


function RolesPage() {
  // const apiUrl = 'http://localhost/server/testServer';
  const apiUrl = 'https://www.albarede.com/server';
  const { t, i18n } = useTranslation();


   const [rules, setRules] = useState([]);
   const [isLoading, setIsLoading] = useState(true); // حالة التحميل

   useEffect(() => {
    fetch(`${apiUrl}/rule.php`)
      .then(response => {
          if (!response.ok) {
              throw new Error('Network response was not ok');
          }
          return response.json();
      })
      .then(rules => {
          const sortedRules = rules.sort((a, b) => new Date(b.createAt) - new Date(a.createAt));
          setRules(sortedRules);
        setIsLoading(false);
      })
      .catch(error => {
          console.error('Error fetching data:', error);
      });
}, []);
if (isLoading) {
  return <LoadingPage />; // عرض صفحة التحميل أثناء التحميل
}

  return (
    <div className='rolesBody'>
        <div className='ruleHead'>
        <PageHead title={t('rules')} 
                  summary={t('rulsShortDisc')}
                  disc={t('rulesPageDisc')}
                  btn={t('rulesPageBtn')}
                  hrefBtn='/articles'/>
        </div>
        <SectionWrap>
            <SectionHeader title={t('rulesPageTitle')} disc={t('rulesPageTitleDisc')}/>
            <div className='rulesContainer'>
               {rules.length > 0 && rules.map(rule => (
               <Rule key={rule.id} id={rule.id} createAt={rule.createAt} ruleText={rule.ruleText} lawType={rule.lawType} lawYear={rule.lawYear} lawRef={rule.lawRef}/>
               ))}
            </div>
        </SectionWrap>
        <div style={{marginBottom: '70px'}}>
        </div>
    </div>
  )
}

export default RolesPage